import React from 'react'

function ContenerAction(props) {
    return <div className="contenerAction">{props.children}</div>
}

export default ContenerAction
